import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { CommonService } from '../../core/services/Common/common.service';
import { HelperService } from '../../core/services/Helper/helper.service';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';

declare var io: any;
declare var $: any;

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule, NgxSpinnerModule, NgbModule, ReactiveFormsModule, FormsModule],
  templateUrl: './default-layout.component.html'
})

export class DefaultLayoutComponent implements OnInit {

  public sidebarMinimized = false;
  subscriptions: Subscription[] = [];
  loading = true;
  isLoading: boolean = false;
  currentPage: any = 1;
  typeSelected: string;
  aboutMe: any = {};
  roleId: string = '';
  imageStatus: number = 0;
  imageBusinessStatus: number = 0;
  imgURL: string = 'assets/images/default_image.jpg';
  imgBusinessURL: string = '';
  imageProfile: any = '';
  iseditImageUrl: any = 'assets/images/no_image_available.png';
  searchStatus: number = 0;
  public is_active: any = localStorage.getItem('is_active');

  condition: boolean = true;
  aboutCondition: boolean = false;
  servicesCondition: boolean = false;
  contactUsCondition: boolean = false;
  enquiries: any = '';
  broadcasts: any = '';
  unreadMessages: any = '';
  isMenu = false;
  bellIconNotification: any = '';
  lastName: any;
  lastNameTrimmed: any;
  nameImage: any = '';
  color: any;
  borderColor: any;
  nameColor: any;
  colorJson: any

  BackgroundColor: any;
  UserNameColor: any;

  show = false
  rentalShow = false;
  repairShow = false;
  spareShow = false;
  dealerShow = false;

  vehicleShow = true;
  ExtravehicleShow = false;

  colouring = false;
  colouringRental = false;
  colouringSpare = false;
  colouringRepair = false;
  colouringDelears = false;

  oneDivVehciles = false;
  oneDivRentalVehciles = false;
  oneDivRepair = false;
  oneDivSpare = false;
  oneDivDealers = false;

  itemCountries: any = [];

  countryId: any = '13414701-f899-41cd-815b-093e21ceffed';
  countryName: any = 'Malawi';
  countryFlagUrl: any = 'https://www.kawawamotorsapi.acelance.com/storage/images/7d722b823d8d7f0adcd28a189de543d283a2.png';

  showDropdown: any = false;
  footerShow: any = false;

  malawicountryFlagUrl = ''
  contact_us_admin_details: any = '';

  planList: any = [];
  planId: any = '';
  planDetails: any;
  showIssueSubscription: any = false;
  alertMessage: any;
  upload_limit: any;
  total_uploaded_products: any;
  pricePlan: any = '';

  userCountryName = '';
  isExtraLarge: any = true;
  vehicleId: any;
  userType: any = 'business'
  currentYear: number = new Date().getFullYear();

  // search:string = ''

  toggleMinimize(e: any) {
    this.sidebarMinimized = e;
  }

  constructor(
    private spinner: NgxSpinnerService,
    private helperService: HelperService,
    private commonService: CommonService,
    private sanitizer: DomSanitizer,
    private router: Router) {
    if (sessionStorage.getItem('stateId')) {
      sessionStorage.clear()
    }

    if (localStorage.getItem('user_type') == 'Private Account') {
      this.isExtraLarge = false
    } else {
      this.isExtraLarge = true
    }

    if (localStorage.getItem('token')) {
      this.commonService.connectSocket();
    }

    this.typeSelected = 'ball-fussion';
    /** spinner starts on init */
    this.spinner.show();

    setTimeout(() => {
      // * spinner ends after 5 seconds 
      this.spinner.hide();
    }, 100);

    if (localStorage.getItem('token')) {
      this.subscriptions.push(
        this.commonService.getUserProfileUpdate().subscribe((result) => {
          this.fetchAboutMe();
        })
      )
    }
    if (localStorage.getItem('token')) {
      this.subscriptions.push(
        this.commonService.getUserStatus().subscribe((result) => {
          this.fetchAboutMe();
        })
      )
    }


    this.subscriptions.push(
      this.commonService.getLogout().subscribe((result) => {
        this.roleId = '';
        this.aboutMe = {};

      })
    )



    this.commonService.currentImage.subscribe(value => {
      if (value == 1) {
        this.fetchAboutMe();
      }
    });

    this.subscriptions.push(
      this.commonService.getChangeCountry().subscribe((result) => {
        this.countryId = localStorage.getItem('countryId');
        this.countryName = localStorage.getItem('countryName');
        this.countryFlagUrl = localStorage.getItem('countryFlag');
      })
    )

    this.subscriptions.push(
      this.commonService.getFooter().subscribe((result) => {
        this.footerShow = result
      })
    )

    this.subscriptions.push(
      this.commonService.getShowSubscription().subscribe((result) => {
        console.log(result, "tmctmctmc")
        this.userType = result
      })
    )


    this.commonService.getPlan().subscribe((result) => {
      this.planList = result;
      this.fetchPlanList();
      localStorage.removeItem('no_subscription')
      if (localStorage.getItem('vehicleId')) {
        this.vehicleId = localStorage.getItem('vehicleId')
      }

    })


    if (localStorage.getItem('user_type') == 'Private Account') {
      this.userType = 'private'
    } else {
      this.userType = 'business'
    }



  }



  ngOnInit(): void {
    if (localStorage.getItem('token')) {
      this.fetchAboutMe();

    }
    this.fetchItemAvailableCountries()

    if (localStorage.getItem('countryId')) {
      this.countryId = localStorage.getItem('countryId');
      this.countryName = localStorage.getItem('countryName');
      this.countryFlagUrl = localStorage.getItem('countryFlag');
    } else {
      this.countryId = '13414701-f899-41cd-815b-093e21ceffed';
      this.countryName = 'Malawi';
      this.countryFlagUrl = this.malawicountryFlagUrl
    }

    if (sessionStorage.getItem('countryId')) {
      this.countryId = sessionStorage.getItem('countryId');
      this.countryName = sessionStorage.getItem('countryName');
      this.countryFlagUrl = sessionStorage.getItem('countryFlag');
    }
    this.fetchContactUsAdminDetails()



  }

  open() {
    this.isMenu = true;
    console.log("xfjfn")
  }


  fetchAboutMe() {
    if (this.searchStatus == 0) {
      this.isLoading = true;
    }
    this.subscriptions.push(
      this.commonService.getAPICall({
        url: 'auth/me',
      }).subscribe((result) => {
        this.isLoading = false;
        if (result.statusCode == 403) {
          localStorage.clear();
          this.router.navigateByUrl('/default', { skipLocationChange: true }).then(() => { this.router.navigate(['users/login']); })
        }
        if (result.statusCode == 401) {
          this.commonService.changeImageFunction(0);
          localStorage.clear();
          this.router.navigateByUrl('/default', { skipLocationChange: true }).then(() => { this.router.navigate(['users/login']); })
        } else {
          if (result.statusCode == 200) {
            localStorage.setItem('is_active', result.data.user.isActive);
            localStorage.setItem('user_type', result.data.user.role.roleName);

            if (localStorage.getItem('user_type') == 'Private Account') {
              this.isExtraLarge = false
            }
            if (this.currentPage == 1) {

              if (result.data.allExpired == 1 && !sessionStorage.getItem('alreadyshown')) {
                sessionStorage.setItem('expired', result.data.allExpired)
              }

              if (sessionStorage.getItem('expired') && !sessionStorage.getItem('alreadyshown') && localStorage.getItem('user_type') != 'Private Account') {
                this.fetchPlanList()
                sessionStorage.setItem('alreadyshown', '1')
              }
              this.aboutMe = result.data.user;
              this.upload_limit = result.data.upload_limit;
              this.total_uploaded_products = result.data.total_uploaded_products;
              this.roleId = result.data.user.role.roleId;
              this.enquiries = this.aboutMe.notifications.enquires;
              this.unreadMessages = this.aboutMe.notifications?.unreadMessages;
              this.bellIconNotification = this.aboutMe.notifications.bellIconNotification;
              this.broadcasts = this.aboutMe.notifications.broadcasts;
              this.userCountryName = this.aboutMe.country.countryName;

              console.log(this.userCountryName, "******************")
              //this.countryFlagUrl = this.aboutMe?.country?.countryFlagUrl;
              console.log(this.bellIconNotification)
              if (this.aboutMe.profileImageUrl) {
                this.imgURL = this.aboutMe.profileImageUrl;
                this.imageStatus = 1;
              } else {
                this.imgURL = '';
                this.colorJson = this.aboutMe.userColor;
                this.color = this.colorJson;
                this.BackgroundColor = this.color.Background;
                this.UserNameColor = this.color.UserNameColor;
                this.borderColor = '3px solid', '' + this.UserNameColor
                console.log(this.BackgroundColor, this.UserNameColor);

                this.nameImage = this.aboutMe.fullName[0]
                if (this.aboutMe.fullName.split(" ").length > 1) {
                  this.lastName = this.aboutMe.fullName.split(" ").pop();
                  this.lastNameTrimmed = this.lastName.charAt(0).toUpperCase();
                  console.log(this.lastNameTrimmed)

                } else {
                  this.lastName = ''
                  this.lastNameTrimmed = ''

                }

              }

              if (this.roleId == '0a7f492c-3322-4a0a-af41-85ce8d551d28') {
                if (this.aboutMe.businessAccount.businessLogoUrl) {
                  this.imgBusinessURL = this.aboutMe.businessAccount.businessLogoUrl;
                  this.imageBusinessStatus = 1;
                } else {
                  this.imgBusinessURL = '';
                  this.colorJson = this.aboutMe.userColor;
                  this.color = this.colorJson;
                  this.BackgroundColor = this.color.Background;
                  this.UserNameColor = this.color.UserNameColor;
                  this.borderColor = '3px solid', '' + this.UserNameColor
                  console.log(this.borderColor);

                  this.nameImage = this.aboutMe.businessAccount.businessName[0].toUpperCase()
                  if (this.aboutMe.businessAccount.businessName.split(" ").length > 1) {
                    this.lastName = this.aboutMe.businessAccount.businessName.split(" ").pop();
                    this.lastNameTrimmed = this.lastName.charAt(0).toUpperCase();;
                    console.log(this.lastNameTrimmed)

                  } else {
                    this.lastName = ''
                    this.lastNameTrimmed = ''
                  }

                }
              }
            }
          }
          else {
            this.helperService.showError(result.message);

          }
        }
      }, (err) => {
        this.isLoading = false;
        this.helperService.showError(err.error.msg);
      })
    )
  }


  login() {

    if (!localStorage.getItem('making_payment')) {
      this.condition = true;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = false;
      this.router.navigate(['users/login']);
    }
  }

  profile() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = true;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = false;
      if (this.roleId == '0a7f492c-3322-4a0a-af41-85ce8d551d28') {
        this.router.navigate(['/users/edit-business-account']);
      }
      if (this.roleId == 'd1b4a3ce-cfb5-420c-98cd-901ce5ab88cd') {
        this.router.navigate(['/users/edit-private-account']);
      }
    }
  }

  indexDashboard() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = true;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = false;
      if (localStorage.getItem('token')) {
        this.router.navigate(["/users/dashboard"]);
      } else {
        this.router.navigate(['/']);
      }
    }
  }

  search() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = true;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = false;

      if (this.router.url == '/index' || this.router.url == '/' || this.router.url == '/users/dashboard') {
        if (sessionStorage.getItem('stateId') || sessionStorage.getItem('makeId')) {
          sessionStorage.clear()
        }

      }
      this.router.navigate(["/users/search"]);
    }

  }

  contactUs() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = false;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = true;
      this.spinner.show();
      setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
      }, 500);
      this.router.navigate(['home/contact-us']);
    }
  }

  aboutUs() {

    if (!localStorage.getItem('making_payment')) {
      this.condition = false;
      this.aboutCondition = true;
      this.servicesCondition = false;
      this.contactUsCondition = false;
      this.router.navigate(['home/about-us']);
    }
  }

  services() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = false;
      this.aboutCondition = false;
      this.servicesCondition = true;
      this.contactUsCondition = false;
      this.spinner.show();
      setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
      }, 500);
      this.router.navigate(['services/service-list'])
    }
  }

  sellItemsListing() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = true;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = false;
      this.spinner.show();
      setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
      }, 500);

      this.router.navigate(['sell-items/sell-items-listing'])
    }
  }

  myEnquiries() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = true;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = false;
      this.router.navigate(['home/my-enquiries']);
      this.enquiries = '';
    }
  }
  myNotifications() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = true;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = false;
      this.router.navigate(['home/my-notifications']);
      this.bellIconNotification = '';
    }
  }


  getInTouch() {
    if (!localStorage.getItem('making_payment')) {
      this.spinner.show();
      setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
      }, 500);
      this.router.navigate(['home/get-in-touch']);
    }
  }

  broadcastes() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = true;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = false;
      this.router.navigate(['home/broadcastes']);
      this.broadcasts = '';
    }
  }

  liveChat() {
    if (!localStorage.getItem('making_payment')) {
      this.router.navigate(['users/live-chat']);
    }
  }

  home() {
    if (!localStorage.getItem('making_payment')) {
      this.condition = true;
      this.aboutCondition = false;
      this.servicesCondition = false;
      this.contactUsCondition = false;
      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
      }, 1000);
      this.router.navigate(['/']);
    }
  }

  vehicleAllList() {
    if (!localStorage.getItem('making_payment')) {
      this.router.navigate(['vehicle-all-list']);
    }
  }

  rentalVehicleAllList() {
    this.router.navigate(['rental-vehicle-all-list']);
  }

  repairGarageAllList() {
    if (!localStorage.getItem('making_payment')) {
      this.router.navigate(['repair-garage-all-list']);
    }
  }

  sparepartAllList() {
    if (!localStorage.getItem('making_payment')) {
      this.router.navigate(['sparepart-all-list']);
    }
  }

  dealersAllList() {
    if (!localStorage.getItem('making_payment')) {
      this.router.navigate(['dealers-all-list']);
    }
  }


  fetchItemAvailableCountries() {
    if (this.searchStatus == 0) {
      this.isLoading = true;
    }
    this.subscriptions.push(
      this.commonService.getAPICall({
        url: 'common/item-available-countries',
      }).subscribe((result) => {
        this.isLoading = false;
        if (result.statusCode == 200) {
          this.itemCountries = result.data.countries;
          for (let it of this.itemCountries) {
            if (it.countryName == 'Malawi') {

              this.malawicountryFlagUrl = it.countryFlagUrl;
              if (localStorage.getItem('countryId')) {
                this.countryId = localStorage.getItem('countryId');
                this.countryName = localStorage.getItem('countryName');
                this.countryFlagUrl = localStorage.getItem('countryFlag');
              } else {
                this.countryId = '13414701-f899-41cd-815b-093e21ceffed';
                this.countryName = 'Malawi';
                this.countryFlagUrl = this.malawicountryFlagUrl
              }
              return
            }
          }
          console.log(this.itemCountries)
        }
        else {
          this.helperService.showError(result.message);
        }
      }, (err) => {
        this.isLoading = false;
        this.helperService.showError(err.error.message);
      })
    )
  }

  change() {
    if (this.showDropdown == false) {
      if (this.itemCountries.length > 0) {
        this.showDropdown = true
      }


    }

    // if(this.showDropdown == true){
    //this.showDropdown = false
    // }
  }

  changeCountry(id, name, flag) {

    localStorage.setItem('countryId', id)
    localStorage.setItem('countryName', name)
    localStorage.setItem('countryFlag', flag)
    if (sessionStorage.getItem('makeId')) {
      sessionStorage.removeItem('countryId')
      sessionStorage.removeItem('stateId')
      sessionStorage.removeItem('cityId')
    } else {
      sessionStorage.clear()
    }

    this.commonService.setChangeCountry({ id: id })
    this.showDropdown = false
  }

  closeDropdown() {
    this.showDropdown = false
  }

  fetchContactUsAdminDetails() {
    this.isLoading = true;
    this.spinner.show();
    this.subscriptions.push(
      this.commonService.getAPICall({
        url: 'common/contact-admin-details',
      }).subscribe((result) => {
        this.isLoading = false;
        this.spinner.hide();
        if (result.statusCode == 403) {
          localStorage.clear();
          this.router.navigateByUrl('/default', { skipLocationChange: true }).then(() => { this.router.navigate(['users/login']); })
        }
        if (result.statusCode == 200) {
          this.contact_us_admin_details = result.data.user;
        }



        else {
          this.helperService.showError(result.message);
        }

      }, (err) => {
        this.isLoading = false;
        this.helperService.showError(err.error.msg);
      })
    )
  }


  fetchPlanList() {
    if (localStorage.getItem('user_type') == 'Private Account') {
      this.isExtraLarge = false
    } else {
      this.isExtraLarge = true
    }
    if (localStorage.getItem('token')) {

      this.isLoading = true;
      this.spinner.show();
      this.subscriptions.push(
        this.commonService
          .getAPICall({
            url: "plan/plan-list",
          })
          .subscribe(
            (result) => {
              this.isLoading = false;
              this.spinner.hide();
              if (result.statusCode == 200) {
                this.planList = [];
                this.planId = '';
                this.alertMessage = result.data.alertMessage;

                for (let item of result.data.plansList) {
                  this.planList.push(item);
                }

                // if (this.planList.length > 0 && localStorage.getItem('user_type') == 'Business') {
                //   this.choosePlan(this.planList[0].planId,this.planList[0].price)
                //   $('#subscription').modal('show');
                // }

                // if (this.planList.length > 0 && localStorage.getItem('user_type') != 'Business') {
                //   this.planId = this.planList[0].planId;
                //   this.pricePlan = this.planList[0].price;
                //   this.showIssueSubscription = false;
                //   $('#subscription').modal('hide');
                //   if (!localStorage.getItem('donotshow')) {
                //     $('#subscription2').modal('show');
                //   }
                //   this.fetchPlanDetails()

                // }


                // if (this.planList.length == 0) {
                //   this.helperService.showError("No subscription plans found");
                //   $('#subscription').modal('hide');
                // }


              } else {
                this.helperService.showError(result.msg);
              }
            },
            (err) => {
              this.isLoading = false;
              this.helperService.showError(err.error.msg);
            },
          ),
      );
    } else {
      this.router.navigateByUrl('/default', { skipLocationChange: true }).then(() => { this.router.navigate(['users/login']); })
    }
  }

  choosePlan(id, price) {
    this.planId = id
    this.pricePlan = price
    this.showIssueSubscription = false;
    this.fetchPlanDetails()
  }

  openDetailsModal() {
    if (this.planId == '') {
      this.showIssueSubscription = true;
      return
    }

    if (localStorage.getItem('user_type') != 'Business') {
      // $('#subscription').modal('hide');
      // $('#subscription2').modal('show');
    }

    if (localStorage.getItem('user_type') != 'Business') {
      this.fetchPlanDetails()
    } else {

      this.submitPlanRequest();

    }


  }

  fetchPlanDetails() {
    this.isLoading = true;
    this.spinner.show();
    this.subscriptions.push(
      this.commonService
        .getAPICall({
          url: "plan/plan-details/" + this.planId,
        })
        .subscribe(
          (result) => {
            this.isLoading = false;
            this.spinner.hide();
            if (result.statusCode == 200) {
              this.planDetails = result.data.plan;

            } else {
              this.helperService.showError(result.msg);
            }
          },
          (err) => {
            this.isLoading = false;
            this.helperService.showError(err.error.msg);
          },
        ),
    );
  }


  submitPlanRequest() {

    let CallBackUrl = '';
    CallBackUrl = environment.callBackUrl + 'home/my-transactions'
    
    let requestConfig = {
      transactionId: this.planDetails.transactionId,
      planId: this.planId,
      vehicleId: this.vehicleId,
      call_back_url: CallBackUrl
    }
    this.isLoading = true;
    this.spinner.show();

    this.subscriptions.push(
      this.commonService.postAPICall({
        url: 'plan/plan-submit-request',
        data: requestConfig
      }).subscribe((result) => {
        this.isLoading = false;
        this.spinner.hide();
        this.commonService.setFooter(true);
        if (result.statusCode == 201) {
          this.helperService.showSuccess(result.message);
         // $('#subscription').modal('hide');
          localStorage.setItem('make_payment', 'true');
         // this.router.navigate(['users/make-payment']);
          window.open(result.data.check_out_url, "_self");

          this.fetchAboutMe();
          this.commonService.setItems({});

        }
        else {
          if (result.statusCode != 400) {
          //  $('#subscription').modal('hide');
            this.helperService.showError(result.message);
          }
          this.helperService.showError(result.data.errors[0].message);
        }
      }, (err) => {
        this.isLoading = false;
        this.helperService.showError(err.error.message);
      })
    )
  }

  isPlanSelected(planId: number): boolean {
    return this.planId === planId;
  }

}





